export const PUBLIC_CDN_URL = "https://cdn.gunesh.uz/static/images/"

export const DefaultRercordsCountPerCategoryCount = 40;
export const DefaultCategoryId = 8;
export const RecommendedCategoryId = 4;
